import { danger } from '../../../../../utils/brand-colors';

export default () => ({
  moveButton: {
    width: 48,
    height: 48,
    margin: 'auto',
  },
  toggleFieldContainer: { display: 'flex' },
  toggleFieldLabelContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  toggleFieldLabel: {
    lineHeight: '48px',
    marginRight: 4,
  },
  dialog: { width: '100%' },
  archiveButton: { color: danger.main },
});
